<template>
  <div v-if="order">
    <modal-edit-pending-information :order="order" v-model="modalOrderEditPendingInformationFlag" v-on:confirm="orderUpdatePendingInformation()"/>
    <modal-invoice :order="order" v-model="modalInvoiceFlag" v-on:confirm="modalInvoice()"/>
    <modal-unlink-order :order="order" v-model="modalUnlinkOrderFlag" v-on:confirm="unlinkOrder()"/>
    <page-title :title="title" :moduleIdentifier="identifier">
      <span slot="header-right" class="badge" :class="order.status">{{ $t(order.status).label }}</span>
    </page-title>

    <div class="l-row">
      <div class="l-col-12 l-col-6@sm l-col-3@lg">
        <box-info :label="$t('date.label')" :value="new Date(order.created.replace('.000Z', '')).toLocaleString('pt-br').split(' ')" icon="icon-calendar" color="t-queue"/>
      </div>
      <div class="l-col-12 l-col-6@sm l-col-3@lg">
        <box-info :label="$t('freightValue.label')" :value="order.payment.shipping | currency" icon="icon-truck" color="t-denied"/>
      </div>
      <div class="l-col-12 l-col-6@sm l-col-3@lg">
        <box-info :label="$t('totalValue.label')" :value="order.payment.total | currency" icon="icon-cash" color="t-success"/>
      </div>
      <div class="l-col-12 l-col-6@sm l-col-3@lg">
        <box-info :label="$t('totalItems.label')" :value="totalItems.toString()" icon="icon-cart" color="t-waiting"/>
      </div>
    </div>

    <panel>
      <div class="l-row">
        <div class="l-col-8@md l-col-offset-2@md">
          <stepper :order="order.marketplace"/>
        </div>
      </div>
    </panel>

    <div class="l-row">
      <div class="l-col-12@md">
        <div class="l-row vertical-flex">
          <div class="l-col-4@md">
            <panel :title="$t('client.label')">
              <div class="l-row" v-if="order.customer">
                <div class="l-col-12@md">
                  <span class="ds-block">
                    <strong>{{ $t('name.label') }}:</strong>
                    {{ hideData(order.customer.name) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ isPersonal ? 'CPF' : 'CNPJ' }}:</strong>
                    {{ hideData(order.customer.documentNumber) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('phone.label') }}:</strong>
                    {{ hideData(order.customer.phone) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('phoneMobile.label') }}:</strong>
                    {{ hideData(order.customer.mobile) | attribute }}
                  </span>
                </div>
              </div>
              <div class="l-row u-textCenter full-height" v-else>
                <div class="l-col-12@md">
                  <div class="vertical-center">
                    Dados não informados
                  </div>
                </div>
              </div>
            </panel>
          </div>

          <div class="l-col-4@md">
            <panel :title="$t('payment.label')">
              <div class="l-row">
                <div class="l-col-6@md">
                  <span class="ds-block">
                    <strong>{{ $t('shippingPrice.label') }}:</strong>
                    {{ order.payment.shipping | currency }}
                  </span>


                  <span class="ds-block">
                    <strong>{{ $t('subtotal.label') }}:</strong>
                    {{ order.payment.subtotal | currency }}
                  </span>

                  <span class="ds-block">
                    <strong>{{ $t('installments.label') }}:</strong>
                    {{ order.payment.installments }}
                  </span>

                  <span class="ds-block">
                    <strong>{{ $t('saleFee.label') }}:</strong>
                    {{ order.payment.saleFee | currency }}
                  </span>

                  <span class="ds-block">
                    <strong>{{ $t('shippingFee.label') }}:</strong>
                    {{ order.payment.shippingFee | currency }}
                  </span>

                </div>

                <div class="l-col-6@md">
                  <span class="ds-block">
                    <strong>{{ $t('discount.label') }}:</strong>
                    {{ order.payment.discount | currency }}
                  </span>

                  <span class="ds-block">
                    <strong>{{ $t('total.label') }}:</strong>
                    {{ order.payment.total | currency }}
                  </span>

                  <span class="ds-block">
                    <strong>{{ $t('addition.label') }}:</strong>
                    {{ order.payment.addition | currency }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('method.label') }}:</strong>
                    {{ getPaymentMethod(order.payment.method) | attribute }}
                  </span>
                </div>
              </div>
            </panel>
          </div>

          <div class="l-col-4@md">
            <panel :title="$t('marketplace.label')">
              <span class="ds-block">
                <strong>{{ $t('identifier.label') }}:</strong>
                {{ order.marketplace.externalReference | attribute }}
              </span>
              <span class="ds-block">
                <strong>{{ $t('date.label') }}:</strong>
               {{ adjustDate(order.marketplace.date) | attribute }}
              </span>
              <span class="ds-block">
                <strong>{{ $t('channel.label') }}:</strong>
                {{ channel | attribute }}
              </span>
              <span class="ds-block">
                <strong>{{ $t('shipmentService.name.label') }}:</strong>
                {{ $t(`shipmentService.${order.marketplace.shipmentService}.label`) | attribute }}
              </span>
            </panel>
          </div>

         <div class="l-col-4@md">
            <panel :title="$t('billingAddress.label')">
              <div class="l-row" v-if="order.customer && order.customer.address">
                <div class="l-col-6@md">
                  <span class="ds-block">
                    <strong>{{ $t('name.label') }}:</strong>
                    {{ hideData(order.customer.address.name) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('street.label') }}:</strong>
                    {{ hideData(order.customer.address.street) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('number.label') }}:</strong>
                    {{ hideData(order.customer.address.number) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('complement.label') }}:</strong>
                    {{ hideData(order.customer.address.complement) | attribute }}
                  </span>
                </div>
                <div class="l-col-6@md">
                  <span class="ds-block">
                    <strong>{{ $t('district.label') }}:</strong>
                    {{ hideData(order.customer.address.district) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('city.label') }}:</strong>
                    {{ hideData(order.customer.address.city) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('state.label') }}:</strong>
                    {{ hideData(order.customer.address.state) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('zipCode.label') }}:</strong>
                    {{ hideData(order.customer.address.zipCode) | attribute }}
                  </span>
                </div>
                <div class="l-col-12@md">
                  <span class="ds-block">
                    <strong>{{ $t('referenceAddress.label') }}:</strong>
                    {{ hideData(order.customer.address.reference) | attribute }}
                  </span>
                </div>
              </div>
              <div class="l-row u-textCenter" v-else>
                <div class="l-col-12@md">
                  Dados não informados
                </div>
              </div>
            </panel>
          </div>

          <div class="l-col-4@md">
            <panel :title="$t('deliveryAddress.label')">
              <div class="l-row" v-if="order.shipping.address">
                <div class="l-col-6@md">
                  <span class="ds-block">
                    <strong>{{ $t('name.label') }}:</strong>
                    {{ hideData(order.shipping.address.name) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('street.label') }}:</strong>
                    {{ hideData(order.shipping.address.street) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('number.label') }}:</strong>
                    {{ hideData(order.shipping.address.number) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('complement.label') }}:</strong>
                    {{ hideData(order.shipping.address.complement) | attribute }}
                  </span>
                </div>
                <div class="l-col-6@md">
                  <span class="ds-block">
                    <strong>{{ $t('district.label') }}:</strong>
                    {{ hideData(order.shipping.address.district) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('city.label') }}:</strong>
                    {{ hideData(order.shipping.address.city) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('state.label') }}:</strong>
                    {{ hideData(order.shipping.address.state) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('zipCode.label') }}:</strong>
                    {{ hideData(order.shipping.address.zipCode) | attribute }}
                  </span>
                </div>
                <div class="l-col-12@md">
                  <span class="ds-block">
                    <strong>{{ $t('referenceAddress.label') }}:</strong>
                    {{ hideData(order.shipping.address.reference) | attribute }}
                  </span>
                </div>
              </div>
              <div class="l-row u-textCenter" v-else>
                <div class="l-col-12@md">
                  Dados não informados
                </div>
              </div>
            </panel>
          </div>

          <div class="l-col-4@md">
            <panel :title="$t('expediter.label')">
              <loader :loading="loadingSyncExpediter"/>
              <div slot="header-right">
                <span class="badge" :class="order.expediter.status">{{ $t(order.expediter.status).label }}</span>
                <button v-if="order.expediter.status !== 'synchronized' && (order.expediter.identifier === 'moovin' || order.expediter.identifier === 'flexy' || order.expediter.identifier === 'oneeg') && order.customer !== null && order.shipping.address !== null" class="btn" title="Sincronizar" @click="syncExpediter">
                  <i class="icon-sync icon-loop2"></i>
                </button>
                <button v-if="order.expediter.identifier == 'moovin' && order.customer !== null && order.shipping.address !== null && order.expediter.shipped == false && order.marketplace.invoiced == false && order.invoice.key == ''" class="btn" title="Desvincular com o Ecommerce" @click="modalUnlinkOrderFlag = true">
                  <i class="btn--danger icon-folder-remove"></i>
                </button>
              </div>

              <div class="l-row">
                <div class="l-col-12@md">
                  <span class="ds-block">
                    <strong>{{ $t('module.label') }}:</strong>
                    {{ $t(`${order.expediter.identifier}.label`) | attribute }}
                  </span>
                  <span class="ds-block">
                    <strong>{{ $t('code.label') }}:</strong>
                    {{ order.expediter.code | attribute }}
                  </span>
                  <span class="ds-block" v-if="order.marketplace.shipmentService">
                    <strong>{{ $t('shipped.label') }}:</strong>
                    {{  $t(`shipmentService.${order.expediter.shipped}.label`) | attribute }}
                  </span>
                  <span class="ds-block" v-if="order.marketplace.shipmentService">
                    <strong>{{ $t('delivered.label') }}:</strong>
                    {{ $t(`shipmentService.${order.expediter.delivered}.label`) | attribute }}
                  </span>
                  <span class="ds-block" v-if="order.expediter.message">
                    <strong>Mensagem:</strong>
                    {{ order.expediter.message | attribute }}
                  </span>
                </div>
              </div>
            </panel>
          </div>
        </div>
      </div>
    </div>

    <div class="l-row vertical-flex">
      <div class="l-col-8@md">
        <div class="l-row">
          <div class="l-col-12@md">
            <panel :title="$t('products.label')">
              <table class="table table--responsive">
                <thead>
                  <tr>
                    <th width="18%">{{ $t('code.label') }}</th>
                    <th width="18%">{{ $t('expediter.code.label') }}</th>
                    <th width="10%" v-if="someItemHaveExternalCode">{{ $t('externalCode.label') }}</th>
                    <th>{{ $t('title.label') }}</th>
                    <th width="10%" class="u-textRight">{{ $t('quantity.label') }}</th>
                    <th class="u-textRight" width="12%">{{ $t('order.item.price.label') }}</th>
                    <th class="u-textRight" width="12%">{{ $t('pricePaid.label') }}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="item in order.shipping.items" :key="item.code">
                    <td :data-label="$t('expediter.code.label')">
                      <input type="text" class="form-input" :value="item.code" @change="fillCode(item, $event)" :disabled="(isOrderSynchronized)">
                    </td>
                    <td :data-label="$t('expediter.code.label')">
                      <input type="text" class="form-input" v-model="item.expediterCode" :disabled="isOrderSynchronized">
                    </td>
                    <td :data-label="$t('externalCode.label')" v-if="someItemHaveExternalCode">{{ item.externalCode }}</td>
                    <td :data-label="$t('title.label')">{{ item.title }}</td>
                    <td :data-label="$t('quantity.label')" class="u-textRight">{{ item.quantity }}</td>
                    <td :data-label="$t('order.item.price.label')" class="u-textRight">{{ item.price | currency }}</td>
                    <td :data-label="$t('pricePaid.label')" class="u-textRight">{{ item.pricePaid | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </panel>
          </div>

          <div class="l-col-12@md">
            <div class="l-row vertical-flex">
              <div class="l-col-12">
                <panel title="Faturamento">
                  <div class="l-row">
                    <form-group :columns="5" label="Chave NF" :error="getError('invoice.key')">
                      <input type="text" :disabled="isBlockedToEditInvoiceData" class="form-input" v-model="order.invoice.key">
                    </form-group>
                    <form-group :columns="2" label="Número NF" :error="getError('invoice.number')">
                      <input type="text" :disabled="isBlockedToEditInvoiceData" class="form-input" v-model="order.invoice.number">
                    </form-group>
                    <form-group :columns="2" label="Série NF" :error="getError('invoice.serial')">
                      <input type="text" :disabled="isBlockedToEditInvoiceData" class="form-input" v-model="order.invoice.serial">
                    </form-group>
                    <form-group :columns="3" label="Data de faturamento" :error="getError('invoice.date')">
                      <el-date-picker
                        v-model="order.invoice.date"
                        type="datetime"
                        placeholder="Data e Hora da postagem"
                        :disabled="isBlockedToEditInvoiceData"
                        format="dd/MM/yyyy HH:mm:ss"
                        timezone="UTC">
                      </el-date-picker>
                    </form-group>

                    <form-group :columns="5" label="Link NF" :error="getError('invoice.link')">
                      <input type="text" :disabled="isBlockedToEditInvoiceData" class="form-input" v-model="order.invoice.link">
                    </form-group>

                    <a class="hint hint--right" data-label="Visualizar XML de nota fiscal"
                       @click="modalInvoiceFlag = true"
                       v-if="order.invoice.xml"><i class="icon icon-file-text invoice-area"></i>
                    </a>

                  </div>
                </panel>
              </div>

              <div class="l-col-12">
                <panel title="Transporte">
                  <div slot="header-right">
                    <a class="hint hint--left" data-label="Imprimir etiqueta" :href="shipmentLabelUrl" target="_blank" v-if="hasPrintShipmentLabel && shipmentLabelUrl"><i class="icon icon-printer"></i></a>
                  </div>

                  <div class="l-col-12 l-row">
                    <form-group :columns="4" label="Número de rastreio">
                      <input type="text" :disabled="isBlockedToEditTransportData" class="form-input" v-model="order.shipping.trackingCode">
                    </form-group>
                    <form-group :columns="4" label="Data da postagem" :error="getError('shipping.postDate')">
                      <el-date-picker
                        v-model="order.shipping.postDate"
                        type="datetime"
                        placeholder="Data e Hora da postagem"
                        :disabled="isBlockedToEditTransportData"
                        format="dd/MM/yyyy HH:mm:ss">
                      </el-date-picker>
                    </form-group>
                    <form-group :columns="2" v-if="identifier === 'integracommerce' && this.defaultEstimatedDays && this.defaultEstimatedDays > 0" label="Dias úteis estimados">
                      <input class="form-input" min="0" type="number" v-model="order.shipping.estimatedDays">
                    </form-group>
                    <form-group :columns="4" label="Data da entrega">
                      <el-date-picker
                        v-model="order.shipping.deliveryDate"
                        type="datetime"
                        placeholder="Data de Entrega"
                        :disabled="isBlockedToEditDeliveryData"
                        format="dd/MM/yyyy">
                      </el-date-picker>
                    </form-group>
                  </div>
                </panel>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="l-col-4@md">
        <simple-list-log :options="logFilters"/>
      </div>
    </div>

    <panel>
      <div class="l-row">
        <div class="l-col-12@md u-textRight">
        <button v-if="order.shippingCustom && identifier === 'mercadoLivre'" @click="modalOrderEditPendingInformationFlag = true" class="btn btn--success" type="submit">
          <i class="icon-pencil size"></i>&nbsp;
          Editar informações pendentes
        </button>
        <button :disabled="!isAllowedToSave && isOrderSynchronized" @click="onSubmit" v-bind:class="{ 'is-loading': saving }" class="btn btn--success u-textRight" type="submit">
          <i class="icon-floppy-disk size"></i>&nbsp;
          Salvar
        </button>
      </div>
      </div>
    </panel>
  </div>
  <loader v-else :loading="loading"/>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import api from '@/api'
  import notifier from '@/notifier'
  import Loader from '@/components/template/Loader'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import BoxInfo from '@/components/template/BoxInfo'
  import PageTitle from '@/components/template/PageTitle'
  import Stepper from '@/components/Order/Shared/Stepper'
  import DateInput from '@/components/template/DateInput'
  import SimpleListLog from '@/components/shared/SimpleListLog'
  import ModalEditPendingInformation from '@/components/Order/Shared/ModalEditPendingInformation'
  import ModalInvoice from '@/components/Order/Shared/ModalInvoice'
  import ModalUnlinkOrder from '@/components/marketplace/shared/ModalUnlinkOrder'
  import { isObject, transform, isEmpty } from 'lodash'

  export default {
    props: {
      identifier: {
        type: String,
        required: true
      },
      code: {
        type: String,
        required: true
      },
      order: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      loading: true,
      syncing: false,
      loadingSyncExpediter: false,
      modalOrderEditPendingInformationFlag: false,
      modalInvoiceFlag: false,
      modalUnlinkOrderFlag: false,
      saving: false,
      defaultEstimatedDays: null,
      logFilters: {
        identifier: null,
        scope: '*order*',
        page: 1,
        limit: 5
      },
      infos: {
        invoice: {
          number: '',
          serial: '',
          key: '',
          date: ''
        },
        shipping: {
          trackingCode: '',
          postDate: '',
          deliveryDate: ''
        }
      },
      shipmentLabelUrl: ''
    }),
    async mounted () {
      this.loading = false

      if (this.order && this.order.marketplace.identifier === 'integracommerce') {
        try {
          this.moduleConfigurations = await api.getConfiguration('marketplace', 'integracommerce')
        } catch (e) {
          notifier.error('Não foi possível buscar as configurações da Integracommerce.')
        }

        if (this.moduleConfigurations && this.moduleConfigurations.order) {
          if (this.moduleConfigurations.order.defaultEstimatedDays > 0) {
            this.defaultEstimatedDays = this.moduleConfigurations.order.defaultEstimatedDays
          }
        }

        if (isEmpty(this.order.shipping.estimatedDays)) {
          this.order.shipping.estimatedDays = this.defaultEstimatedDays
        }
      }
    },
    methods: {
      ...mapActions('orders', [
        'updateInfo',
        'syncOrder',
        'synchronizeOrderExpediter',
        'unlinkOrderFromExpediter',
        'addOrder'
      ]),
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      omit (obj) {
        function omitFromObject (obj) {
          return transform(obj, function (result, value, key) {
            if (value === '' || value === undefined || value === null) {
              return
            }

            result[key] = isObject(value) ? omitFromObject(value) : value
          })
        }

        return omitFromObject(obj)
      },
      fillCode (item, event) {
        item.code = event.target.value
      },
      async onSubmit () {
        this.clearErrors()

        this.saving = true

        const items = this.order.shipping.items
          .map(item => ({
            code: item.code,
            expediterCode: item.expediterCode
          }))

        this.infos = {
          invoice: {
            number: this.order.invoice.number,
            serial: this.order.invoice.serial,
            key: this.order.invoice.key,
            date: this.order.invoice.date ? this.order.invoice.date : '',
            link: this.order.invoice.link
          },
          shipping: {
            trackingCode: this.order.shipping.trackingCode ? this.order.shipping.trackingCode : null,
            postDate: this.order.shipping.postDate ? this.order.shipping.postDate : null,
            deliveryDate: this.order.shipping.deliveryDate ? this.order.shipping.deliveryDate : null,
            estimatedDays: this.order.shipping.estimatedDays ? this.order.shipping.estimatedDays : null
          }
        }

        if (this.isBlockedToEditInvoiceData && isEmpty(this.omit(this.infos.invoice))) {
          delete this.infos.invoice
        }

        const promises = []

        if (!this.isOrderSynchronized) {
          promises.push(
            api.updateOrderItemsInfo(this.identifier, this.code, { items: items })
              .then(() => notifier.success('Dados dos itens salvo com sucesso!', 'Salvo'))
              .catch(() => notifier.error('Não foi possível salvar os dados dos itens!', 'Erro'))
          )
        } else {
          if (this.isAllowedToSave) {
            promises.push(
              this.updateInfo({
                identifier: this.identifier,
                code: this.code,
                info: this.infos
              })
                .then(() => notifier.success('Dados salvo com sucesso!', 'Salvo'))
                .catch(err => {
                  if (err.response.data.data !== undefined) {
                    for (var i in err.response.data.data) {
                      const error = err.response.data.data[i]
                      this.addError({
                        property: error.property,
                        error: {
                          message: error.constraint,
                          value: error[error.constraint]
                        }
                      })
                    }
                  }
                  notifier.error('Não foi possível salvar os dados!', 'Erro')
                })
            )
          }
        }

        Promise.all(promises)
          .finally(() => { this.saving = false })
      },
      syncExpediter () {
        this.loadingSyncExpediter = true
        if (this.order.marketplace.identifier === 'amazon' && this.order.status === 'pending') {
          notifier.error('Não é possível sincronizar pedidos Amazon com status Pendente.', 'Erro')
          this.loadingSyncExpediter = false
          return
        }
        this.synchronizeOrderExpediter({ type: this.order.expediter.type, identifier: this.order.expediter.identifier, code: this.order._id.$oid })
          .finally(() => { this.loadingSyncExpediter = false })
      },
      async orderUpdatePendingInformation () {
        this.loading = true
        try {
          const orderUpdated = await api.mercadoLivre.updateOrderPendingInformations(this.order)
          notifier.success('Pedido atualizado com sucesso.', 'Atualização do pedido')
          this.order.payment.total = orderUpdated.payment.total
        } catch (e) {
          notifier.error('Falha ao atualizar o pedido.', 'Erro')
        }
        this.loading = false
        this.modalOrderEditPendingInformationFlag = false
      },
      modalInvoice () {
        this.modalInvoiceFlag = false
      },
      async unlinkOrder () {
        this.loading = true

        this.unlinkOrderFromExpediter({type: this.order.expediter.type, orderId: this.order._id.$oid, identifierExpediter: this.order.expediter.identifier}).finally(() => { this.loading = false })

        await new Promise(resolve => setTimeout(resolve, 2000))
        window.location.reload()
      },
      hideData (data) {
        if (data !== null && data !== '') {
          let firstLetter = data.substr(0, 1)
          let lastLetter = data.substr(-1, 1)
          let star = '*'
          if (data.length > 3) {
            return `${firstLetter}${star.repeat(data.length)}${lastLetter}`
          } else {
            return `${star.repeat(data.length)}`
          }
        }
      },
      adjustDate (date) {
        const orderMarketplaceDate = new Date(date)

        orderMarketplaceDate.setTime(orderMarketplaceDate.getTime() + orderMarketplaceDate.getTimezoneOffset() * 60 * 1000)

        let minutes = orderMarketplaceDate.getMinutes()
        minutes = minutes > 9 ? minutes : '0' + minutes
        return `${('0' + orderMarketplaceDate.getDate()).slice(-2)}/${('0' + (orderMarketplaceDate.getMonth() + 1)).slice(-2)}/${orderMarketplaceDate.getFullYear()} ${orderMarketplaceDate.getHours()}:${minutes}`
      },
      getPaymentMethod (method) {
        switch (method) {
          case 'Other':
            return 'Outros'
          case 'CreditCard':
            return 'Cartão de crédito'
          default:
            return method
        }
      }
    },
    computed: {
      ...mapGetters('orders', [
        'getByMarketplaceIdentifierAndCode'
      ]),
      ...mapGetters('errors', [
        'getError'
      ]),
      order () {
        let order = this.getByMarketplaceIdentifierAndCode(this.identifier, this.code)

        if (order !== undefined) {
          this.logFilters.identifier = order.marketplace.code
          this.logFilters['module_identifier'] = order.marketplace.identifier

          order.shipping.postDate = order.shipping.postDate ? order.shipping.postDate : null

          order.shipping.deliveryDate = order.shipping.deliveryDate ? order.shipping.deliveryDate : null

          if (!order.invoice) {
            order.invoice = this.infos.invoice
          }

          if (order.marketplace.identifier === 'mercadoLivre') {
            api.mercadoLivre.getShipmentLabelUrl([order.marketplace.code], order.marketplace.account.identifier)
              .then(shipmentLabel => {
                this.shipmentLabelUrl = shipmentLabel.url
              })
              .catch(() => { this.shipmentLabelUrl = '' })
          }

          if (order.marketplace.identifier === 'integracommerce') {
            api.integracommerce.getShipmentLabelUrl([order.marketplace.code])
              .then(shipmentLabel => {
                this.shipmentLabelUrl = shipmentLabel.url
              })
              .catch(() => { this.shipmentLabelUrl = '' })
          }

          return order
        }

        this.addOrder({
          identifier: this.identifier,
          code: this.code
        })
      },
      title () {
        return `Pedido #${this.order.marketplace.externalReference}`
      },
      totalItems () {
        let total = 0
        this.order.shipping.items.forEach((item) => {
          total += item.quantity
        })
        return total
      },
      isPersonal () {
        return this.order.customer.type === 'personal'
      },
      isBlockedToEditInvoiceData () {
        return (this.order.status === 'approved' && this.order.marketplace.invoiced) || this.order.status !== 'approved'
      },
      isBlockedToEditTransportData () {
        return (this.order.status === 'approved' && this.order.marketplace.shipped) || this.order.status !== 'approved'
      },
      isBlockedToEditDeliveryData () {
        return (this.order.status === 'approved' && this.order.marketplace.delivered) || this.order.status !== 'approved'
      },
      isAllowedToSave () {
        return !this.isBlockedToEditTransportData || !this.isBlockedToEditDeliveryData || !this.isBlockedToEditInvoiceData
      },
      isOrderSynchronized () {
        return this.order.expediter.status === 'synchronized'
      },
      hasPrintShipmentLabel () {
        return this.order.status === 'approved' && this.order.marketplace.shipmentService && (
          this.order.marketplace.identifier === 'mercadoLivre' ||
          this.order.marketplace.identifier === 'skyhub' ||
          this.order.marketplace.identifier === 'integracommerce'
        )
      },
      channel () {
        if (this.order.marketplace.identifier === 'mercadoLivre') {
          return `${this.order.marketplace.channel} (${this.order.marketplace.account.nickname})`
        }
        return this.order.marketplace.channel
      },
      someItemHaveExternalCode () {
        return this.order.shipping.items.some(item => (item.externalCode !== undefined && item.externalCode !== null))
      }
    },
    components: {
      FormGroup,
      Panel,
      PageTitle,
      Stepper,
      BoxInfo,
      Loader,
      DateInput,
      ModalEditPendingInformation,
      ModalInvoice,
      ModalUnlinkOrder,
      SimpleListLog
    }
  }
</script>

<style lang="sass">
  .divider > span > i
    margin-right: 3px

  .form-control
    .el-date-editor--daterange.el-input,
    .el-date-editor--daterange.el-input__inner,
    .el-date-editor--timerange.el-input,
    .el-date-editor--timerange.el-input__inner,
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner
      width: 100%
      padding: 0
      height: 34px

  .el-input--prefix .el-input__inner
    padding-left: 10px

  .el-input__icon
    line-height: 0

  .el-input__prefix
    .el-icon-time
      &::before
        content: none

  .icon-printer
    margin-right: 6px

  .invoice-area
    padding: 33px 0 0 8px
</style>



// WEBPACK FOOTER //
// Base.vue?13eb380b